let measurementContext: CanvasRenderingContext2D | null = null;

const getMeasurementContext = (): CanvasRenderingContext2D | null => {
  if (!measurementContext) measurementContext = document.createElement("canvas").getContext("2d");
  return measurementContext;
};

const getRootFontSize = (): number => parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;

// Theme typography sizes are rem strings; canvas font shorthand needs an absolute length
const cssLengthToPixels = (length: string | number | undefined): number => {
  if (typeof length === "number") return length;
  if (!length) return 0;

  const value = parseFloat(length);
  if (Number.isNaN(value)) return 0;

  return length.trim().endsWith("rem") ? value * getRootFontSize() : value;
};

export const buildCanvasFont = (fontWeight: number, fontSize: string | number | undefined, fontFamily: string | undefined): string =>
  `${fontWeight} ${cssLengthToPixels(fontSize)}px ${fontFamily || "sans-serif"}`;

export const measureTextWidth = (text: string, font: string): number => {
  const context = getMeasurementContext();
  if (!context) return 0;

  context.font = font;
  return context.measureText(text).width;
};

export const measureWidestText = (texts: string[], font: string): number => {
  const context = getMeasurementContext();
  if (!context) return 0;

  context.font = font;
  return texts.reduce((widest, text) => Math.max(widest, context.measureText(text).width), 0);
};

export const measureTotalTextWidth = (texts: string[], font: string): number => {
  const context = getMeasurementContext();
  if (!context) return 0;

  context.font = font;
  return texts.reduce((total, text) => total + context.measureText(text).width, 0);
};
